import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FilmStripLoader from '../components/FilmStripLoader';

import registerBg from "../../src/assets/images/login.png";

const Register = () => {
  const [formData, setFormData] = useState({
    email: '',
    username: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const { register } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Simulate page load
    setTimeout(() => {
      setIsLoading(false);
      setTimeout(() => {
        setShowLoader(false);
      }, 600);
    }, 500);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await register(formData.username, formData.email, formData.password);
      navigate('/');
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        err.response?.data?.errors?.[0]?.msg ||
        'Registration failed. Please try again.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  if (showLoader) {
    return (
      <div className={isLoading ? '' : 'fade-out-loader'}>
        <FilmStripLoader />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#141414] flex flex-col overflow-x-hidden">
      <Header />

      <div className="flex-1 w-full max-w-[1240px] mx-auto px-4 py-12 flex items-center justify-center">
        <div className="w-full flex items-center gap-10 justify-center">
          

          {/* Card */}
          <div className="w-full max-w-[520px] bg-[#1A1A1A] rounded-3xl p-6 sm:p-8 shadow-xl flex flex-col gap-5 border border-[#262626] animate-page-enter">
            <h1 className="text-3xl font-bold text-white text-center">
              Rejoignez H4KIG
            </h1>

            {/* Tabs */}
            <div className="w-full max-w-[420px] mx-auto flex gap-2 bg-[#FFFFFF1C] p-2 rounded-full">
              <Link
                to="/login"
                className="flex-1 px-5 sm:px-10 py-2 text-white hover:bg-white hover:text-black transition rounded-full text-center whitespace-nowrap"
              >
                Connexion
              </Link>
              <button className="flex-1 px-5 sm:px-10 py-2 bg-white text-black rounded-full whitespace-nowrap">
                Inscription
              </button>
            </div>

            <p className="text-white/80 text-center">
              Créez votre compte et commencez à regarder instantanément.
            </p>

            {error && (
              <div className="p-3 bg-red-900/50 border border-red-700 rounded text-red-200 text-sm">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">
              {/* Email */}
              <div>
                <label className="block text-white mb-2">Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Entrez votre email"
                  className="w-full px-4 py-3 bg-transparent text-white rounded-lg border border-white/60 focus:border-white focus:outline-none"
                  required
                />
              </div>

              {/* Username */}
              <div>
                <label className="block text-white mb-2">Nom d'utilisateur</label>
                <input
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  placeholder="Entrez votre nom d'utilisateur"
                  className="w-full px-4 py-3 bg-transparent text-white rounded-lg border border-white/60 focus:border-white focus:outline-none"
                  required
                />
              </div>

              {/* Password */}
              <div>
                <label className="block text-white mb-2">Mot de passe</label>
                <div className="relative">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Entrez votre mot de passe"
                    className="w-full px-4 py-3 bg-transparent text-white rounded-lg border border-white/60 focus:border-white focus:outline-none pr-12"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white"
                  >
                    {showPassword ? (
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3l18 18" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.6 10.6a3 3 0 004.24 4.24" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.88 9.88A3 3 0 0115 12" />
                      </svg>
                    ) : (
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>

              {/* Submit */}
              <button
                type="submit"
                disabled={loading}
                className="w-full py-3 bg-white text-black rounded-lg font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? 'Création du compte...' : 'S\'inscrire'}
              </button>
            </form>
          </div>
          {/* Image LEFT */}
          <img
            src={registerBg}
            alt="Register"
            className="hidden min-[1080px]:block w-[700px] h-[576px] object-cover"
          />          
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Register;
